import { z } from "zod";
import type { FeatureDefinitionBase } from "../types/feature-definition.types.js";
import { BaseFeatureConfigSchema } from "../schemas/base-feature-config.schemas.js";
import { FeatureCategory } from "../schemas/feature-category.schemas.js";
import { FeatureKey } from "../schemas/feature-key.schemas.js";

export const PROFILE_EDITABLE_FIELDS = [
  "firstName",
  "lastName",
  "fullName",
  "title",
  "bio",
  "summary",
] as const;

export type ProfileEditableFieldType = (typeof PROFILE_EDITABLE_FIELDS)[number];

const LocalizedTextConfigSchema = z.object({
  lang: z.string(),
  content: z.string(),
  translations: z.record(z.string(), z.string()).optional(),
});

const ExternalEditConfigSchema = z.object({
  url: z.url(),
  text: LocalizedTextConfigSchema,
});

export const ProfileUserEditLockedFieldsFeatureConfigSchema =
  BaseFeatureConfigSchema.extend({
    lockedFields: z.array(z.enum(PROFILE_EDITABLE_FIELDS)).readonly(),
    instructions: LocalizedTextConfigSchema.nullable(),
    externalEdit: ExternalEditConfigSchema.nullable(),
  });

export type ProfileUserEditLockedFieldsFeatureConfig = z.infer<
  typeof ProfileUserEditLockedFieldsFeatureConfigSchema
>;

export const ProfileUserEditLockedFieldsFeatureDefinition: FeatureDefinitionBase<ProfileUserEditLockedFieldsFeatureConfig> =
  {
    key: FeatureKey.PROFILE_USER_EDIT_LOCKED_FIELDS,
    name: "Profile User Edit Locked Fields",
    description:
      "Controls which profile fields are locked from user editing per event",
    category: FeatureCategory.PARTICIPANT,
    defaultConfig: {
      active: true,
      lockedFields: [],
      instructions: null,
      externalEdit: null,
    },

    disabledConfig: {
      active: false,
      lockedFields: [],
      instructions: null,
      externalEdit: null,
    },
  };
